import { Card as AntCard } from 'antd';
import styled, { css } from 'styled-components';
import { withPrivacy } from 'components/atoms/private';
import { StatusIndicator as StatusIndicatorAtom } from 'components/molecules/status-indicator';

export const Wrapper = styled.div`
  display: flex;
  margin-top: var(--spacing-04);
`;

export const StatusIndicator = styled(StatusIndicatorAtom)`
  margin: var(--spacing-02) 0 var(--layout-01) 0;
`;

export const HeaderSectionWrapper = styled.div`
  display: flex;
  margin-bottom: var(--layout-01);
`;

export const HeaderSection = styled.div`
  flex: 1;
  margin-right: var(--layout-05);
`;

export const ContentWrapper = styled.div`
  flex: 1;
  margin-left: var(--layout-01);
`;

export const Card = withPrivacy(
  styled(AntCard)`
    box-shadow: var(--shadow-01);
    max-height: calc(100vh - 222px);
    margin: 0 auto;
    overflow: auto;

    .ant-card-head {
      border-top: solid 4px var(--task-pane-header-bg);
    }
  `,
  css`
    .ant-card-head {
      border-top-color: var(--yellow-40);
    }
  `,
);
